var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "ugc-design-view"
  }, [_c('section', {
    staticClass: "ugc-design-view-wrapper"
  }, [_c('base-spinner'), _c('fabric-canvas', {
    ref: "fabCanvas",
    attrs: {
      "name": "fabCanvas"
    }
  }, [_c('gcc-auto-update'), _c('placement-mask', {
    on: {
      "placement-loaded": _vm.onPlacementLoaded
    }
  }), _c('uploaded-image', {
    on: {
      "image-loaded": _vm.onUploadedImageLoaded
    }
  })], 1)], 1), _c('ugc-tools')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }